import React from 'react';

import { Box, Text } from '@betterment/samba-react';

import { SambaAutoLink } from '../../../features/navigation/SambaAutoLink';
import { ModalSection } from '../../modal-section/ModalSection';
import { ModalSectionRow } from '../../modal-section/ModalSectionRow';
import { formatLegalAccountType } from '../helpers';

import type { AccountSettingsUrlBuilders, RenderCloseAccountAction } from '../contentTypes';
import type { DirectTradingAccount } from '../data';

type DirectTradingAccountSettingsProps = {
  account: DirectTradingAccount;
  urlBuilders: Pick<AccountSettingsUrlBuilders, 'accountDetails' | 'editPortfolio' | 'legalAccounts'>;
  renderCloseAccount?: RenderCloseAccountAction;
};

export const DirectTradingAccountSettings: React.FC<DirectTradingAccountSettingsProps> = ({
  account,
  urlBuilders,
  renderCloseAccount,
}) => {
  const { legalAccount } = account;
  const legalAccountType = formatLegalAccountType(legalAccount);
  const hasBeneficiaries = legalAccount.primaryBeneficiaries.length > 0;

  const closeAccountAction =
    renderCloseAccount &&
    renderCloseAccount({
      balance: account.balance,
      purposeName: account.envelope.purpose?.name,
      name: account.name,
      legacyAccountId: account.legacySubAccountId,
    });

  return (
    <Box css={{ display: 'grid', gap: 'space.200' }}>
      <ModalSection header="Account details" cta={urlBuilders.accountDetails}>
        <ModalSectionRow>
          <ModalSectionRow.LeadingContent>
            <Text>Account type</Text>
          </ModalSectionRow.LeadingContent>
          <ModalSectionRow.TrailingContent>
            <Text>{legalAccountType}</Text>
          </ModalSectionRow.TrailingContent>
        </ModalSectionRow>
        {!hasBeneficiaries && urlBuilders.legalAccounts && (
          <ModalSectionRow>
            <ModalSectionRow.LeadingContent>
              <Text>Beneficiaries</Text>
            </ModalSectionRow.LeadingContent>
            <ModalSectionRow.TrailingContent>
              <SambaAutoLink to={urlBuilders.legalAccounts}>Add beneficiary</SambaAutoLink>
            </ModalSectionRow.TrailingContent>
          </ModalSectionRow>
        )}
      </ModalSection>
      {closeAccountAction}
    </Box>
  );
};
